var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"glBackground",staticClass:"webgl-backround"},[_c('img',{ref:"image",attrs:{"src":"/assets/images/teaser.jpg","alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }